import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-value"]
const _hoisted_2 = ["data-value"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_portal = _resolveComponent("app-portal")

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      ref: "trigger",
      class: "gfu-floating-content-trigger",
      "data-value": _ctx.guid,
      onMouseover: _cache[0] || (_cache[0] = (...args) => ($options.onMouseOver && $options.onMouseOver(...args))),
      onMouseleave: _cache[1] || (_cache[1] = (...args) => ($options.onMouseLeave && $options.onMouseLeave(...args))),
      "data-qa": "floating-content:trigger"
    }, [
      _renderSlot(_ctx.$slots, "trigger")
    ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_1),
    ($props.isContentVisible)
      ? (_openBlock(), _createBlock(_component_app_portal, {
          key: 0,
          to: "#floating-content"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              ref: "content",
              class: _normalizeClass(['gfu-floating-content', $props.contentWrapperClass]),
              "data-value": _ctx.guid,
              onMouseover: _cache[2] || (_cache[2] = (...args) => ($options.onMouseOver && $options.onMouseOver(...args))),
              onMouseleave: _cache[3] || (_cache[3] = (...args) => ($options.onMouseLeave && $options.onMouseLeave(...args))),
              "data-qa": "floating-content:content"
            }, [
              _renderSlot(_ctx.$slots, "content")
            ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_2)
          ]),
          _: 3 /* FORWARDED */
        }))
      : _createCommentVNode("v-if", true)
  ]))
}